export const CUSTOMER_SOURCE_ID = "8bed991c68a470e7aaeffbf048"

export const BASIC_STATUS_ID = "8fd73167342d06899c4c015320"

export const LOBSTER_FRIEND_STATUS_ID = "83d1d11ea3884a5d33253fe214"

export const CUSTOMER_VISIT_EVENT_TYPE_ID = "8bc3862c17c2779fefd2e0362f"